import type { FunctionComponent } from 'react'
import ViewerInfoBar from '../../../../shared/components/ViewerInfoBar/ViewerInfoBar'
import useParam from '../../../../shared/hooks/useParam'
import { locationParam } from '../../query-params'
import { useMapContext } from '../../../../shared/contexts/map/MapContext'

const PanoramaViewerInfoBar: FunctionComponent = () => {
  const [location] = useParam(locationParam)
  const { showLargeMap } = useMapContext()
  const { panoFullScreen, panoImageDate } = useMapContext()

  if (!location || !panoImageDate) {
    return null
  }

  return (
    <ViewerInfoBar
      date={panoImageDate}
      location={location}
      panoFullScreen={panoFullScreen}
      showLargeMap={showLargeMap}
    />
  )
}

export default PanoramaViewerInfoBar
